import React, { useEffect } from "react";

import TablaContrato from "../gestionEmpleado/gestionLaboral/TablaContrato";
import { dbx } from "../../utils/urlBack_End";
import { clientesApi } from "src/services/clientesApi";

export default function ContratosCliente(props) {
  const { value, cliente, setShowMessage, setColor, setMessage } = props;
  const { data } = clientesApi.useGetContratoClienteQuery(cliente.rut);
  const contratos = data ?? [];

  useEffect(() => {
    if (cliente.rut !== undefined) {
      dbx
        .filesListFolder({ path: `/Clientes/${cliente.rut}/Contratos` })
        .then(() => {})
        .catch(() => {
          dbx
            .filesCreateFolderV2({
              path: `/Clientes/${cliente.rut}/Contratos`,
            })
            .then((response) => {})
            .catch((error) => {});
        })
        .finally(() => {});
    }
  }, [cliente.rut]);
  return (
    <>
      {value === 10 && (
        <>
          <TablaContrato
            contratos={contratos}
            empleado={cliente}
            setShowMessagePermiso={setShowMessage}
            setColor={setColor}
            setMessage={setMessage}
            vista={undefined}
          />
        </>
      )}
    </>
  );
}
